export default __webpack_public_path__ + "static/media/recovery_icon.d4ce77c7.png";